import React from 'react';
import PropTypes from 'prop-types';

/**
 * The "Link" in LinkBar
 * @param {children} param0 children of LinkBarItem
 * @param {url} param1 url for click
 * @param {external} param2 does link outside of site
 * @returns {JSX} LinkBarItem
 */
const LinkBarItem = ({ children, url, external }) =>
  external ? (
    <a className="linkBar__item__link" href={url}>
      {children}
    </a>
  ) : (
    <a className="linkBar__item__link" href={url}>
      {children}
    </a>
  );

LinkBarItem.defaultProps = {
  external: false
};

LinkBarItem.propTypes = {
  children: PropTypes.node.isRequired,
  url: PropTypes.string.isRequired,
  external: PropTypes.bool
};

export const LinkBar = ({ items = [] }) => (
  <div id="linkBar" className="linkBar">
    <div className="linkBar__inner">
      <div className="linkBar__itemContainer">
        {items.map(item => {
          const { label, url, active, slug } = item;
          return (
            <div
              key={slug}
              className={`linkBar__item ${
                active ? 'linkBar__item--active' : ''
              }`}
            >
              <LinkBarItem url={url}>{label}</LinkBarItem>
            </div>
          );
        })}
      </div>
    </div>
  </div>
);

LinkBar.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })
  ).isRequired
};
